module.exports = __webpack_public_path__ + "static/media/star.c71278e7.jpg";